export default "__VITE_ASSET__BC9K2eWd__"